import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useApp } from '../../../contexts/AppContext';
import { useUninstallAppForUser } from '../../../hooks/mutations/useUninstallAppForUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CanReinstallDescription({
  isSuperAdmin,
  isIntegrationsManagementWriteUser,
  user
}) {
  if (isSuperAdmin) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "app-governance-lib.uninstallModal.isSuperAdminUser",
      options: {
        user: formatName({
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email
        })
      }
    });
  }
  if (isIntegrationsManagementWriteUser) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "app-governance-lib.uninstallModal.isAppInstallUser",
      options: {
        user: formatName({
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email
        })
      }
    });
  }
  return null;
}
export function UninstallModal({
  onClose,
  user,
  isSuperAdmin,
  isIntegrationsManagementWriteUser
}) {
  const {
    appName
  } = useApp();
  const {
    uninstallAppForUser,
    loading,
    error
  } = useUninstallAppForUser(user, onClose);
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.uninstallModal.title"
    }),
    description: /*#__PURE__*/_jsxs(Flex, {
      gap: "400",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "app-governance-lib.uninstallModal.description",
        options: {
          user: formatName({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email
          }),
          appName
        }
      }), /*#__PURE__*/_jsx(CanReinstallDescription, {
        isSuperAdmin: isSuperAdmin,
        isIntegrationsManagementWriteUser: isIntegrationsManagementWriteUser,
        user: user
      })]
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.uninstallModal.confirm"
    }),
    ConfirmButton: LoadingButton,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.uninstallModal.reject"
    }),
    confirmButtonProps: {
      use: 'danger',
      loading,
      failed: !!error
    },
    onConfirm: uninstallAppForUser,
    onReject: onClose
  });
}